// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1LeQS","logo":"Header_logo__euief","iconWrapper":"Header_iconWrapper__5jeZz","appStoreIcon":"Header_appStoreIcon__10YkX"};